import { createResource } from '@atlassian/react-resource-router';
import getData, { type Project } from './get-data/index.tsx';

const RESOURCE_TYPE_CSM_BASE_URL = 'L1_CUSTOMERS_PROJECT';

export const l1CustomersProjectProviderResource = createResource<Project | null>({
	type: RESOURCE_TYPE_CSM_BASE_URL,
	getKey: () => 'l1-customers-project',
	getData: async () => getData(),
	maxAge: 60 * 60 * 1000, // 1 hour
});
